var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIconPlaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4545 26.0835L31.2731 42.0835C30.7718 42.7421 29.9958 43.1315 29.1691 43.1368H29.1505C28.3318 43.1368 27.5585 42.7581 27.0518 42.1128L20.5665 33.8275C19.6598 32.6701 19.8625 30.9928 21.0225 30.0861C22.1798 29.1768 23.8598 29.3795 24.7665 30.5421L29.1211 36.1048L39.2118 22.8541C40.1025 21.6835 41.7745 21.4541 42.9505 22.3475C44.1211 23.2408 44.3478 24.9128 43.4545 26.0835ZM32.0011 5.80347C17.2731 5.80347 5.33447 17.7421 5.33447 32.4701C5.33447 47.1955 17.2731 59.1368 32.0011 59.1368C46.7291 59.1368 58.6678 47.1955 58.6678 32.4701C58.6678 17.7421 46.7291 5.80347 32.0011 5.80347Z",
    fill: "#128A08"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconPlaid);
export default __webpack_public_path__ + "static/media/successIconPlaid.ccf7b1ddcf1d247aad84c0959d66f6b3.svg";
export { ForwardRef as ReactComponent };